/*
  State - API Object
  {
    "stateId": null,
    "stateAbbr": "AL",
    "stateName": "Alabama",
    "country": "US"
  }
*/
export const normalizeState = ({ stateAbbr, stateName, country }) => ({
  code: stateAbbr,
  name: stateName,
  country
});

export const filterByCountry = (country, state) => state.country === country;
